import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  class: "upload border border-gray-300 rounded p-4 flex justify-between items-center"
};
const _hoisted_2 = {
  class: "tip text-xs text-gray-400 cursor-default"
};
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, "上传参考图(选填)", -1);
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "mt-1"
}, "支持JPG、PNG、10M以内", -1);
const _hoisted_5 = [_hoisted_3, _hoisted_4];
const _hoisted_6 = {
  class: "flex"
};
const _hoisted_7 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Remove = _resolveComponent("Remove");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_UploadFilled = _resolveComponent("UploadFilled");
  const _component_el_button = _resolveComponent("el-button");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_withDirectives(_createElementVNode("div", _hoisted_2, _hoisted_5, 512), [[_vShow, _ctx.uploadImgs.length === 0]]), _createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.uploadImgs, item => {
    return _openBlock(), _createElementBlock("div", {
      key: item,
      class: "mr-1 cursor-pointer relative overflow-visible justify-center items-center flex"
    }, [_createElementVNode("img", {
      class: "w-12 h-12 object-contain rounded",
      src: `${item}`
    }, null, 8, _hoisted_7), _createVNode(_component_el_icon, {
      onClick: $event => _ctx.removeImg(item),
      class: "absolute text-red-500 -right-2 -top-2",
      size: "12"
    }, {
      default: _withCtx(() => [_createVNode(_component_Remove)]),
      _: 2
    }, 1032, ["onClick"])]);
  }), 128))]), _createVNode(_component_el_button, {
    loading: _ctx.uploadLoading,
    onClick: _ctx.uploadFile
  }, {
    default: _withCtx(() => [_createVNode(_component_el_icon, {
      class: "text-indigo-400 cursor-pointer hover:text-indigo-500",
      size: "28"
    }, {
      default: _withCtx(() => [_createVNode(_component_UploadFilled)]),
      _: 1
    })]),
    _: 1
  }, 8, ["loading", "onClick"]), _createElementVNode("input", {
    onChange: _cache[0] || (_cache[0] = (...args) => _ctx.changeFile && _ctx.changeFile(...args)),
    ref: "inputFile",
    accept: "image/*",
    type: "file",
    class: "hidden"
  }, null, 544)]);
}